export const ERROR_MESSAGE = '[ERROR MESSAGE] ERROR';
export const WARNING_MESSAGE = '[ERROR MESSAGE] WARNING';
export const INFORMATION_MESSAGE = '[ERROR MESSAGE] INFORMATION';
export const SUCCESS_MESSAGE = '[ERROR MESSAGE] SUCCESS';
export const HIDE_MESSAGE = '[ERROR MESSAGE] HIDE MESSAGE';
